import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { CustomField } from './custom-field.model';

export enum ContactDetailsEnum {
  phone = 'phone',
  website = 'website',
  email = 'email',
}

export enum NumOfEmployeesEnum {
  _0 = '0',
  _1 = '1',
  _2 = '2',
  _3 = '3',
  _4 = '4',
  _5 = '5',
  _6_to_10 = '6-10',
  _11_to_15 = '11-15',
  _16_or_more = '16+',
}

export const COMPANY_INFO_SCHEMA = Object.freeze({
  NAME: '',
  ADDRESS: '',
  DESCRIPTION: '',
  CONTACT_DETAILS: List<CustomField>([]),
  LEGAL_REGISTRATIONS: List<CustomField>([]),
  ADDITIONAL_INFORMATION: '',
  INDUSTRY: null, // ''
  SUB_INDUSTRIES: List<string>([]),
  NUM_OF_EMPLOYEES: null, // NumOfEmployeesEnum
});
const RECORD = generateSchema(COMPANY_INFO_SCHEMA);
const KEYS: any = generateKeys(COMPANY_INFO_SCHEMA);

export class CompanyInfo extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));

    const selfModel = setInModel(this, [
      {
        key: KEYS.CONTACT_DETAILS,
        value: this.contactDetails.map((params) => new CustomField(params)),
      },
      {
        key: KEYS.LEGAL_REGISTRATIONS,
        value: this.legalRegistrations.map((params) => new CustomField(params)),
      },
    ]);

    return selfModel as CompanyInfo;
  }

  get name(): string {
    return this.get(KEYS.NAME);
  }

  get address(): string {
    return this.get(KEYS.ADDRESS);
  }

  get description(): string {
    return this.get(KEYS.DESCRIPTION);
  }

  get contactDetails(): List<CustomField> {
    return this.get(KEYS.CONTACT_DETAILS);
  }

  get legalRegistrations(): List<CustomField> {
    return this.get(KEYS.LEGAL_REGISTRATIONS);
  }

  get additionalInformation(): string {
    return this.get(KEYS.ADDITIONAL_INFORMATION);
  }

  get industry(): string {
    return this.get(KEYS.INDUSTRY);
  }

  get subIndustries(): List<string> {
    return this.get(KEYS.SUB_INDUSTRIES);
  }

  get numOfEmployees(): NumOfEmployeesEnum {
    return this.get(KEYS.NUM_OF_EMPLOYEES);
  }
}
